import { Capacitor } from '@capacitor/core';

/** True when running inside a Capacitor native shell (Android/iOS APK). */
export function isNativePlatform(): boolean {
  return Capacitor.isNativePlatform();
}
